import { DisplayElementModel } from '../../../Common/PageBuilder/models/display-element.model';
import { TextStyleModel } from '../../../Common/PageBuilder/models/text-style.model';
import { WireContactModel } from './wire-contact.model';


export class ContactDisplayElementModel extends DisplayElementModel {
    declare styles: TextStyleModel;
    contact: WireContactModel;
    placeholderHeight: number = 120;

    constructor(
        contact?: WireContactModel,
    ) {
        super();

        this.contact = !!contact ? contact : new WireContactModel();
        this.styles = new TextStyleModel();
    }

    canRender(): boolean {
        return !!this.contact.name
            || !!this.contact.email
            || !!this.contact.title
            || !!this.contact.contactImageUrl
            || !! this.contact.primaryPhone
            || !!this.contact.secondaryPhone;
    }

    clone(): ContactDisplayElementModel {
        return new ContactDisplayElementModel(this.contact.toApiModel());
    }

    onUpdate(): boolean {
        return true;
    }

    isEqual(other: ContactDisplayElementModel): boolean {
        if (!other) {
            return false;
        }

        if (!other.contact || !this.contact.equals(other.contact)) {
            return false;
        }

        return true;
    }
}
